import type { IconProps } from './types';

const ImageXIcon = (props: IconProps) => {
  const { color = 'currentColor', size = 24, ref, ...other } = props;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 23 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...other}
      ref={ref}
    >
      <path d="M12 16.6875H0.75V0.75H16.6875V11.9835" stroke={color} strokeWidth="1.5" />
      <path
        d="M11.5312 4.03125C10.4957 4.03125 9.65625 4.87072 9.65625 5.90625C9.65625 6.94178 10.4957 7.78125 11.5312 7.78125C12.5668 7.78125 13.4062 6.94178 13.4062 5.90625C13.4062 4.87072 12.5668 4.03125 11.5312 4.03125Z"
        stroke={color}
        strokeWidth="1.5"
      />
      <path d="M0.75 14.8125L6.375 9.1875L11.0625 13.875" stroke={color} strokeWidth="1.5" />
      <path d="M14.1094 13.875L21.6094 21.375M14.1094 21.375L21.6094 13.875" stroke={color} strokeWidth="1.5" />
    </svg>
  );
};

export { ImageXIcon };
